module.exports = __webpack_public_path__ + "media/60.9c1a8afc.mp3";